import { cn } from "@newxsystems/shared";
import type { IImageComponentProps } from "@newxsystems/types";
import { getComponent } from "../../../../client";
import { HeroContent } from "../HeroContent/HeroContent";
import type { IHeroBackgroundImageProps } from "./HeroBackgroundImage.props";

const spacingClasses = {
  tight: "py-14 md:py-20",
  normal: "py-20 md:py-28",
  loose: "py-28 md:py-36",
};

export const HeroBackgroundImage = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  image,
  parentClass,
  spacing,
}: IHeroBackgroundImageProps) => {
  const Image = getComponent<IImageComponentProps>("Image");

  if (!Image) {
    return null;
  }

  return (
    <section
      className={cn(
        "relative isolate flex min-h-[600px] w-full overflow-hidden border-b border-foreground bg-foreground md:min-h-[680px]",
        parentClass,
      )}
      id={anchorId ?? undefined}
    >
      <Image
        alt={image.image.alternateText}
        className="absolute inset-0 max-w-none"
        decoding="async"
        imageClassName="object-cover"
        loading="eager"
        priority
        sizes={image.image.sizes ?? undefined}
        src={image.image.defaultSrc}
        srcSet={image.image.srcSet ?? undefined}
      />
      <div
        className={cn(
          "absolute inset-0",
          alignment === "center"
            ? "bg-foreground/65"
            : "bg-[linear-gradient(90deg,rgba(16,14,12,0.88)_0%,rgba(16,14,12,0.58)_48%,rgba(16,14,12,0.12)_100%)] md:bg-[linear-gradient(90deg,rgba(16,14,12,0.88)_0%,rgba(16,14,12,0.56)_46%,rgba(16,14,12,0.08)_78%)]",
        )}
      />
      <div
        className={cn(
          "container relative z-10 flex w-full items-end",
          spacingClasses[spacing ?? "normal"],
          alignment === "center" && "items-center",
        )}
      >
        <div className="w-full">
          <HeroContent
            alignment={alignment}
            buttons={buttons}
            description={description}
            eyebrow={eyebrow}
            heading={heading}
            inverse
          />
        </div>
      </div>
    </section>
  );
};

HeroBackgroundImage.displayName = "Hero::HeroBackgroundImage";
